import { Component, EventEmitter, Input, Output } from '@angular/core';

// example of usage
// <app-data-binding-popup-form
//   *ngIf="is_show_pushback_popup"
//   (hideAllModalsE)="hideAllModals()"
//   (updateLoadingE)="updateLoadingEvent($event)"
//   (addPushbackDataToDocumentE)="addPushbackDataToDocument()"
//   (resetDataAndUpdateErrorE)="resetDataAndUpdateErrorEvent($event)"
//   [recordType]="pushback_type"
//   [isNeedShowForm]="display_pushback"
//   [document]="selected_pushback_document"
//   [sfObjectsSuggestionList]="sfObjectsList"
//   [isUserOwnerOfDocument]="is_user_owner_of_selected_document"
// >
// </app-data-binding-popup-form>

@Component({
  selector: 'app-data-binding-popup-form',
  templateUrl: './data-binding-popup-form.component.html',
  styleUrls: ['./data-binding-popup-form.component.css']
})
export class DataBindingPopupFormComponent {
  @Output() public updateLoadingE: EventEmitter<any> = new EventEmitter();
  @Output() public resetDataAndUpdateErrorE: EventEmitter<any> = new EventEmitter();
  @Output() public addPushbackDataToDocumentE: EventEmitter<any> = new EventEmitter();
  @Output() public hideAllModalsE: EventEmitter<any> = new EventEmitter();
  @Input() document: any; // Object
  @Input() isNeedShowForm: boolean = true;
  @Input() isUserOwnerOfDocument: boolean = true;
  @Input() sfObjectsSuggestionList: string[] = [];
  @Input() recordType: any = { name: '' };

  constructor() {}

  updateLoading({ state, msg }) {
    this.updateLoadingE.emit({ state, msg });
  }
  resetDataAndUpdateError(errorMsg, isHideModal = false, updLoadingState = false, updLoadingMsg = '') {
    this.resetDataAndUpdateErrorE.emit({ errorMsg, isHideModal, updLoadingState, updLoadingMsg });
  }
  addPushbackDataToDocument() {
    this.addPushbackDataToDocumentE.emit();
  }
  hideAllModals() {
    this.hideAllModalsE.emit();
  }
}
